import React, { useEffect, useState } from "react";
import api, { describeError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

const empty = { what_happened: "", order_result: "", notes: "", next_hearing_date: "", next_hearing_time: "", next_action: "" };

export default function HearingCompleteDialog({ open, onOpenChange, hearing, onSaved }) {
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (open) setForm(empty); }, [open]);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async () => {
    if (!hearing?.id) return;
    setSaving(true);
    try {
      await api.post(`/hearings/${hearing.id}/complete`, form);
      toast.success("Hearing marked as completed");
      onSaved?.();
      onOpenChange(false);
    } catch (err) {
      toast.error(describeError(err, "Could not complete the hearing."));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-navy">Complete Hearing</DialogTitle>
          <DialogDescription>Record what happened and schedule the next hearing if any.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="space-y-1.5"><Label className="text-xs text-muted-foreground">Hearing Outcome</Label><Textarea data-testid="complete-outcome-input" value={form.what_happened} onChange={set("what_happened")} rows={2} placeholder="What happened at the hearing" /></div>
          <div className="space-y-1.5"><Label className="text-xs text-muted-foreground">Order / Result</Label><Input data-testid="complete-order-input" value={form.order_result} onChange={set("order_result")} placeholder="Order passed / result" /></div>
          <div className="space-y-1.5"><Label className="text-xs text-muted-foreground">Notes</Label><Textarea value={form.notes} onChange={set("notes")} rows={2} /></div>
          <div className="rounded-md border border-border bg-secondary/40 p-3">
            <p className="mb-2 text-xs font-medium text-navy">Next Hearing (optional)</p>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-1.5"><Label className="text-xs text-muted-foreground">Date</Label><Input type="date" data-testid="complete-next-date-input" value={form.next_hearing_date} onChange={set("next_hearing_date")} /></div>
              <div className="space-y-1.5"><Label className="text-xs text-muted-foreground">Time</Label><Input type="time" value={form.next_hearing_time} onChange={set("next_hearing_time")} /></div>
            </div>
            <div className="mt-3 space-y-1.5"><Label className="text-xs text-muted-foreground">Next Action</Label><Input value={form.next_action} onChange={set("next_action")} placeholder="e.g. File written submissions" /></div>
          </div>
        </div>
        <DialogFooter>
          <Button onClick={save} disabled={saving} data-testid="complete-save-btn" className="bg-navy text-white hover:bg-navy-light">{saving ? "Saving…" : "Mark Completed"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
